// Tipo do pedido/serial na lista unificada (contrato 00: "grading" | "extended_art").

export const GRADING_KIND = "grading";
export const EXTENDED_ART_KIND = "extended_art";

export const isExtendedArt = (item) => item?.kind === EXTENDED_ART_KIND;

export const KIND_LABELS = {
    [GRADING_KIND]: "Grading",
    [EXTENDED_ART_KIND]: "Arte estendida",
};

export const KIND_FILTER_OPTIONS = [
    { value: "", label: "Todos" },
    { value: GRADING_KIND, label: KIND_LABELS[GRADING_KIND] },
    { value: EXTENDED_ART_KIND, label: KIND_LABELS[EXTENDED_ART_KIND] },
];

/** Rota do detalhe: o estendido tem rota própria (/manafix/extended-art/:id), que renderiza o OrderPage com o kind. Aceita linha da lista (`_id`) ou item da Home (`id`). */
export const orderPath = (item) => {
    const id = item?._id || item?.id;
    return isExtendedArt(item) ? `/manafix/extended-art/${id}` : `/manafix/products/${id}`;
};

/** Separa uma seleção de ids pelo `kind` das linhas carregadas; id sem linha conhecida conta como grading. */
export const splitIdsByKind = (ids, rows) => {
    const extendedIds = new Set((rows || []).filter(isExtendedArt).map((row) => row._id));
    const grading = [];
    const extended = [];
    for (const id of ids || []) {
        (extendedIds.has(id) ? extended : grading).push(id);
    }
    return { grading, extended };
};
